var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
import i18n from 'roddeh-i18n';
import cart from '../services/cart';
import Scrollbar from 'perfect-scrollbar';
import { formatPrice } from '../helpers/prices';
let CartMini = class CartMini extends LitElement {
    constructor() {
        super(...arguments);
        this.totalProducts = -1;
        this.totalGifts = -1;
        this.productsValue = -1;
        this.deliveryFee = null;
        this.freeDeliveryFrom = null;
        this.paymentFee = null;
        this.totalValue = -1;
        this.currency = '';
        this.decimalDigits = 2;
        this.rumankuVouchers = false;
        this.rumankuVouchersSku = '';
        this.cartMiniShowReferenceSKU = false;
        this.products = [];
        this.contents = '';
        this.promotions = [];
        this.scrollbar = null;
    }
    static get styles() {
        return css `
            :host > div {
                cursor: pointer;
                user-select: none;
                width: 100%;
                height: 100%;
                display: flex;
                position: relative;
            }
            .loading-blur {
                filter: blur(1px);
            }
            :host > div > span {
                position: absolute;
                top: 0;
                right: -5px;
                width: 100%;
                text-align: center;
                background: var(--color-important-accents);
                color: var(--inverse-font-color);
                display: inline-block;
                width: auto;
                border-radius: 5em;
                width: 1.6em;
                height: 1.6em;
                line-height: 1.7em;
            }

            :host > div > img {
                height: 2.2rem;
                margin-top: 0;
                margin-bottom: 0;
            }

            @media (max-width: 1000px) {
                :host > div > img {
                    height: 3em;
                }
            }

            @media (max-width: 425px) {
                :host > div > img {
                    height: 2.5em;
                }
            }
            @media (max-width: 425px) {
                .cartmini .text-summary {
                    display: none;
                }
            }
            .cartmini .text-summary > b {
                white-space: nowrap;
            }
            .cartmini .text-summary > p {
                font-weight: normal;
                margin: 0;
                max-height: 2.4em;
                overflow: hidden;
            }
            .cartmini .summary {
                visibility: hidden;
                opacity: 0;
                transition: opacity 0.3s ease-out;
                background: #fff;
                position: absolute;
                top: 100%;
                padding: 1em;
                width: 23rem;
                right: 0;
                text-align: left;
                box-shadow: 0 0 6px 0 rgba(96, 71, 46, 0.875);
                color: #60472e;
                font-size: 0.9rem;
                text-transform: none;
                cursor: default;
            }
            .summary hr {
                border: none;
                border-bottom: 1px solid #dad4c5;
            }
            @media (any-hover) {
                .cartmini:hover .summary {
                    visibility: visible;
                    opacity: 1;
                }
            }
            .summary .btn {
                display: block;
                padding: 0.8em 1em;
                background: #143616;
                text-align: center;
                margin-top: 1em;
                transition: background 0.3s ease-out;
                font-weight: bold;
                text-decoration: none;
                text-transform: uppercase;
                color: #fcf8f1;
            }
            .summary .btn:hover {
                background: #081609;
            }
            .summary > b {
                display: flex;
                justify-content: space-between;
            }
            .summary > b.big {
                font-size: 1.1em;
            }
            .important {
                color: #b4023f;
            }
            .products {
                position: relative;
                max-height: 40vh;
            }
            .products > div {
                display: flex;
                align-items: center;
                margin-bottom: 0.5em;
            }
            .products > div > img {
                height: 3.5em;
                width: 3.5em;
            }
            .products > div > div:nth-child(2) {
                flex: 1 0;
                padding: 0 1em 0.5em;
                white-space: normal;
            }
            .products > div > div:nth-child(2) b {
                margin-bottom: 0.3em;
                display: block;
            }
            .products > div > div:nth-child(2) p {
                font-weight: 400;
                margin: 0;
                font-size: 0.9em;
                line-height: 1em;
            }
            .products > div > div:nth-child(3) {
                font-size: 1.1em;
                color: #b4023f;
            }
        `;
    }
    render() {
        let cssJsMinHash = null;
        if (typeof window.__STATE__ !== 'undefined') {
            cssJsMinHash = window.__STATE__.system.css_js_min_hash;
        }
        return html ` <link
                rel="stylesheet"
                href="/css/layout/perfect-scrollbar.css${cssJsMinHash ? '?t=' + cssJsMinHash : ''}"
            />
            <div class="cartmini">
                <img src="/img/header/icon/ico-basket.svg" />
                ${this.totalProducts === -1
            ? html `<span class="loading-blur">0</span>`
            : html `<span>${this.totalProducts}</span>`}
                ${this.totalProducts !== -1
            ? html `
                          <div class="summary" @click=${this.preventSummaryClick}>
                              <b>${i18n('Cart')}</b>
                              <hr />
                              <b>${this.contents}</b>
                              ${this.products.length > 0
                ? html `
                                        <hr />
                                        <div class="products">
                                            ${this.products.map((product) => html `
                                                    <div>
                                                        ${this.rumankuVouchers === true &&
                    product.code === this.rumankuVouchersSku
                    ? html ` <img src="/img/cart/online_voucher_cart.png" /> `
                    : html `
                                                                  <img src="${product.image_url ?? '/img/ts.gif'}" />
                                                              `}
                                                        <div>
                                                            <b>${product.name}</b>
                                                            ${product.is_gift
                    ? ''
                    : html `
                                                                      <p>
                                                                          ${this.cartMiniShowReferenceSKU === true &&
                        product.code !== this.rumankuVouchersSku
                        ? html `
                                                                                    ${i18n('Reference')}:
                                                                                    ${product.code}<br />
                                                                                    <br />
                                                                                `
                        : ''}
                                                                          ${i18n('Quantity')}: ${product.quantity}
                                                                      </p>
                                                                  `}
                                                        </div>
                                                        <div>
                                                            ${product.total_price > 0
                    ? `${formatPrice(product.total_price)}`
                    : i18n('Free')}
                                                        </div>
                                                    </div>
                                                `)}
                                        </div>
                                    `
                : ''}
                              <hr />
                              <b class="big"
                                  >${i18n('Products value')}
                                  <span class="important">${formatPrice(this.productsValue)}</span></b
                              >
                              ${this.deliveryFee !== null
                ? html `<hr />
                                        <b>${i18n('Delivery fee')} <span>${formatPrice(this.deliveryFee)}</span></b>`
                : ''}
                              ${this.paymentFee !== null && (this.showZeroPaymentFee || this.paymentFee > 0)
                ? html `<hr />
                                        <b>${i18n('Payment fee')} <span>${formatPrice(this.paymentFee)}</span></b>`
                : ''}
                              <hr />
                              <b class="big important"
                                  >${i18n('Total to pay')} <span>${formatPrice(this.totalValue)}</span></b
                              >
                              <a href="/cart" class="btn"> ${i18n('Show my cart')} </a>
                          </div>
                      `
            : ``}
            </div>`;
    }
    preventSummaryClick(e) {
        if (e.target instanceof HTMLElement && e.target.classList.contains('btn')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
    }
    updateSummary() {
        cart.getSummary()
            .then((summary) => {
            this.updateState(summary);
        })
            .catch((err) => {
            console.error('Failed to get cart summary', err);
        });
    }
    updateState(summary) {
        this.totalProducts = summary.products_summary.total_products;
        this.totalGifts = summary.products_summary.total_gifts;
        this.productsValue = summary.products_summary.products_value;
        this.totalValue = summary.products_summary.total_value;
        this.deliveryFee = summary.delivery !== null ? summary.delivery.cost : null;
        this.freeDeliveryFrom = summary.delivery !== null ? summary.delivery.freeDeliveryFrom : null;
        this.paymentFee =
            typeof summary.payment !== 'undefined' && summary.payment !== null ? summary.payment.cost : null;
        this.products = summary.products;
        this.contents = summary.contents;
        this.promotions = summary.promotions;
    }
    connectedCallback() {
        super.connectedCallback();
        if (typeof window.__STATE__ !== 'undefined') {
            this.currency = window.__STATE__.localization.currency;
            this.decimalDigits = window.__STATE__.localization.decimal_digits;
            this.rumankuVouchers = window.__STATE__.functions.rumanku_vouchers;
            this.rumankuVouchersSku = window.__STATE__.functions.rumanku_vouchers_sku;
            this.cartMiniShowReferenceSKU = window.__STATE__.functions.cart_mini_show_reference_sku;
        }
        // Jeżeli mamy w cache, ładujemy od razu ostatni stan koszyka
        const lastState = cart.getLastSummary();
        if (lastState !== null) {
            this.updateState(lastState);
        }
        // Nasłuchujemy na zmianę zawartości koszyka
        cart.addListener((event) => {
            if (event.name === 'cartUpdate' ||
                event.name === 'discountCodeAdded' ||
                event.name === 'voucherAdded' ||
                event.name === 'rowRemoved') {
                this.updateSummary();
            }
        });
        // Przyszłościowo można rozważyć zaprzestanie odpytywania API co załadowanie strony
        this.updateSummary();
    }
    updated() {
        if (this.scrollbar === null && this.shadowRoot !== null) {
            const productsContainer = this.shadowRoot.querySelector('.products');
            if (productsContainer !== null) {
                this.scrollbar = new Scrollbar(productsContainer);
            }
        }
        else if (this.scrollbar !== null) {
            this.scrollbar.update();
        }
    }
    get showZeroPaymentFee() {
        if (typeof window.__STATE__ === 'undefined') {
            return false;
        }
        return window.__STATE__.functions.payment_fee_visibility_for_zero;
    }
};
__decorate([
    property({ type: Number })
], CartMini.prototype, "totalProducts", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "totalGifts", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "productsValue", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "deliveryFee", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "freeDeliveryFrom", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "paymentFee", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "totalValue", void 0);
__decorate([
    property({ type: String })
], CartMini.prototype, "currency", void 0);
__decorate([
    property({ type: Number })
], CartMini.prototype, "decimalDigits", void 0);
__decorate([
    property({ type: Boolean })
], CartMini.prototype, "rumankuVouchers", void 0);
__decorate([
    property({ type: String })
], CartMini.prototype, "rumankuVouchersSku", void 0);
__decorate([
    property({ type: Boolean })
], CartMini.prototype, "cartMiniShowReferenceSKU", void 0);
__decorate([
    property({ type: Array })
], CartMini.prototype, "products", void 0);
__decorate([
    property({ type: String })
], CartMini.prototype, "contents", void 0);
__decorate([
    property({ type: Array })
], CartMini.prototype, "promotions", void 0);
CartMini = __decorate([
    customElement('cart-mini')
], CartMini);
export default CartMini;
